import React from 'react';
import { connect } from 'react-redux';

import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import removeTags from 'service_modules/utils/text-remove-tags';
import { makeGetLinks, getUpgradeCta, makeGetCardData } from '../redux';
import { mapUrlWithDtmLinkQuery } from 'service_modules/models/dtm-tagging';

import styles from '../__styles__/tncs.scss?modules';

const Tncs = ({ links = [], isUpgradeCta, cardObj, position = 'Top' }) => {
  const keys = isUpgradeCta
    ? ['offerTermsUpgrade', 'ratesFeesUpgrade']
    : ['offerTerms', 'ratesFees'];

  return (
    <div className={styles.container}>
      {keys.map((linkType, i) => {
        const link = links[linkType];
        if (!link) {
          return null;
        }
        const { text, url } = link;
        const ariaLabel = removeTags(`${text} for ${cardObj?.cardTitle}`);
        const tagName =
          linkType.indexOf('offerTerms') > -1 ? 'Offer&Benefits' : 'Rates&Fees';
        const dtm = {
          type: 'linknav',
          tag: `${cardObj.dtmProductName}-${tagName}-${position}`
        };
        const hasHash = url.indexOf('#') > -1;
        const arrParts = url.split('#');
        const urlUpdated = `${mapUrlWithDtmLinkQuery(arrParts[0], dtm)}${
          hasHash ? '#' + arrParts[1] : ''
        }`;

        return (
          <a
            className={styles.tnc}
            key={i}
            href={urlUpdated}
            target="_blank"
            rel="noreferrer"
            aria-label={ariaLabel}
          >
            <Sanitizer safelySetInnerHTML={text} />
          </a>
        );
      })}
    </div>
  );
};

const mapStateToProps = () => {
  const getLinks = makeGetLinks();
  const getCardObj = makeGetCardData();
  return (state, { shortName }) => {
    return {
      links: getLinks(state, shortName),
      isUpgradeCta: getUpgradeCta(state, shortName).needUpgradeCta,
      cardObj: getCardObj(state, shortName)
    };
  };
};

export default connect(mapStateToProps)(Tncs);
